module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external {"root":"glamorous","commonjs2":"glamorous","commonjs":"glamorous","amd":"glamorous"}
// module id = 1
// module chunks = 0